import { useState } from "react";
import { DocArchive } from "../../axios";
import { DateUtils } from "../../utils/DateUtils";
import { DbUtils } from "../../utils/DbUtils";
import { ErrorUtils } from "../../utils/ErrorUtils";
import { HtmlUtils } from "../../utils/HtmlUtils";
import ArchiveEdit from "./ArchiveEdit";

interface Props {
	/** 検索履歴Id */
	searchId: string,

	/** 送信履歴一覧 */
	archives: DocArchive[],
};

/**
 * 送信履歴一覧用コンポーネント
 * 
 * @returns 
 */
export default function ArchiveList(props: Props): JSX.Element {

	/** 編集中文書アーカイブ */
	const [editArchive, setEditArchive] = useState<DocArchive | undefined>(undefined);

	/**
	 * ダウンロードボタンクリック時イベント
	 */
	const handleCommit = async () => {
		try {
			await DbUtils.getDownloadApi().createDownload({
				search_id: props.searchId
			});
			alert('ダウンロードファイル作成依頼を行いました。\n作成終了までしばらくお待ちください。');
		} catch (error) {
			ErrorUtils.alert(error);
		}
	};

	/**
	 * プレビューボタンクリック時イベント
	 */
	const handleDownloadClick = async (id: string) => {
		try {
			const res = await DbUtils.getArchiveApi().getArchiveUrl(id);
			HtmlUtils.download(res.data.url!);
		} catch (error) {
			ErrorUtils.alert(error);
		}
	};

	/**
	 * 修正ボタンクリック時イベント
	 */
	const handleEditClick = (archive: DocArchive) => {
		setEditArchive(archive);
	};

	/**
	 * 修正確定時イベント
	 * 
	 * @param archive 
	 */
	const handleEditCommit = (archive: DocArchive) => {
		setEditArchive(undefined);
	};

	/**
	 * 修正キャンセル時イベント
	 */
	const handleEditCancel = () => {
		setEditArchive(undefined);
	};

	/** 1行描画する。 */
	const renderRow = (archive: DocArchive) => {
		return (
			<tr>
				<td>
					<button className="btn btn-default btn-primary pull-center" type="button" onClick={() => handleDownloadClick(archive._id!)}>プレビュー</button>
					&nbsp;
					<button className="btn btn-default btn-primary pull-center" type="button" onClick={() => handleEditClick(archive)}>修正</button>
				</td>
				<td>{DateUtils.formatDate(archive.send_date)}</td>
				<td>{DateUtils.formatDate(archive.issued_date)}</td>
				<td style={{ wordBreak: 'break-all' }}>{archive.customer}</td>
				<td style={{ wordBreak: 'break-all' }}>{archive.doc_name}</td>
				<td style={{ wordBreak: 'break-all' }}>{archive.file_name}</td>
				<td style={{ whiteSpace: 'nowrap', textAlign: 'right' }}>{archive.amount?.toLocaleString()}円</td>
				<td style={{ wordBreak: 'break-all' }}>{archive.search_key_1}</td>
				<td style={{ wordBreak: 'break-all' }}>{archive.search_key_2}</td>
				<td style={{ wordBreak: 'break-all' }}>{archive.search_key_3}</td>
			</tr>
		);
	};

	// 描画する
	return (
		<>
			<hr />
			<div className="control-group">
				<div className="controls">
					<button className="btn btn-default btn-primary pull-center" type="button" onClick={handleCommit}>ダウンロードファイル作成</button>
				</div>
			</div>
			<div style={{ width: '100%' }}>
				<table width="100%" className="dlist" id="table01">
					<tbody>
						<tr>
							<th style={{ width: '160px' }}></th>
							<th>送信日</th>
							<th>発行日</th>
							<th>取引先</th>
							<th>文書名</th>
							<th>ファイル名</th>
							<th>金額</th>
							<th>キー１</th>
							<th>キー２</th>
							<th>キー３</th>
						</tr>
						{props.archives.map(archive => renderRow(archive))}
					</tbody>
				</table>
			</div>
			{editArchive != undefined && <ArchiveEdit archive={editArchive} onCommit={handleEditCommit} onCancel={handleEditCancel} />}
		</>
	);
}